import React from 'react';

import { Section, Stack, Alert } from '@gogame/components';

export const PartnerCampaignIdSection = ({ fields, creator }) => {
  return (
    <Section
      title={'Campaign Matching Attributes'}
      prompt={creator}
      initialOpen={false}
      isCollapsable={true}
    >
      <Stack direction={'column'} spacing={3}>
        <Alert severity={'info'}>
          Enter the exact name of the campaign in the 'Alternative campaign
          name' field for matching.
        </Alert>
        <div>{fields}</div>
      </Stack>
    </Section>
  );
};
